import ReviewPatientToggle from './ReviewPatientToggle';

export {
  useMarkPatientReviewedMutation,
  useUndoPatientReviewedMutation,
} from './reviewPatientApi';

export default ReviewPatientToggle;
